import React, { Component } from 'react'
import Tabs from '../../../chassis/tabs'
import { AdminBannerOtherPanel } from './adminBannerOtherPanel'
import { User } from '../../../core/types'

export interface Props {
  user: User
}

export class AdminBannerTabs extends Component<Props> {
  static displayName = 'AdminBannerTabs'

  render() {
    const { user } = this.props
    const defaultActiveTabIndex = 0

    return (
      <Tabs
        defaultActiveTabIndex={defaultActiveTabIndex}
        data-test="user-banner-tabs"
        className="user-banner__tabs"
        render={({ List, Tab, Panel }) => (
          <div>
            <List>
              <Tab index={0}>Other</Tab>
            </List>
            <Panel index={0}>
              <AdminBannerOtherPanel user={user} />
            </Panel>
          </div>
        )}
      />
    )
  }
}
